const handleEnterPress = (e, onEnter) => {
  if (e.key === "Enter" || e.keyCode === 13) {
    onEnter();
  }
};

export default handleEnterPress;
